import { TTabs } from "../TTabs";
export var TableViewTabs = TTabs;
